import { FigmaLoadingScreen } from './FigmaLoadingScreen';
import { setupFigmaRetry } from '~/lib/figma';
import { useFigmaImport, StatusKind } from '~/lib/figma/useFigmaImport';

export function useFigmaImportScreen(connected: boolean) {
  const { tasks, target, messages, status } = useFigmaImport(connected);

  const ready = status.type === StatusKind.Done;

  const loadingScreen = !ready && (
    <FigmaLoadingScreen
      tasks={tasks}
      status={status}
      target={target}
      onDismiss={() => {
        window.location.href = '/';
      }}
      onTryAgain={() => {
        setupFigmaRetry();
        window.location.href = '/';
      }}
    />
  );

  return {
    loadingScreen,
    messages,
  };
}
